module.exports = __webpack_public_path__ + "static/media/dsb-BEER.a5b36723.jpg";